// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"48c13e26","190":"a374dc68","226":"f5c590e1","249":"0de26edb","284":"47b25652","452":"5497f07d","487":"15985181","607":"f5c590e1","664":"58edc016","726":"56c05ec2","845":"f5c590e1","954":"a214f0da","988":"f5c590e1"}[chunkId] + ".chunk.js";
};